export default {
  root: {
  },
  editor: {
    borderBottom: '1px solid gray'
  },
  editorContainer: {
  }
};
